var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-col md:w-full"},[_c('vx-tooltip',{attrs:{"text":"Phản hồi","position":"top"}},[_c('feather-icon',{staticClass:"action-success mt-4",attrs:{"icon":"MessageCircleIcon","svgClasses":"h-5 w-5 hover:text-primary cursor-pointer"},on:{"click":_vm.editRecord}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }